import { withNamespaces } from "react-i18next";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button
} from "reactstrap";

const PlotValidationFailModal = ({ t, isOpen, toggle, title, body }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle} className="text-danger">
                <div className="text-danger d-flex justify-content-center align-items-center">
                    <i className="ri-error-warning-line me-2"></i>
                    {title}
                </div>
            </ModalHeader>
            <ModalBody>
                {body}
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={toggle}>
                    {t('OK')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(
    PlotValidationFailModal
);
